import { css } from '@emotion/react';

export const checkbox = css`
  gap: 5px;
  display: flex;
`;
